import { FC, Fragment, useEffect, useState } from 'react';
import { services } from '@project/API';
import { Button, Divider, Pagination, Spin } from 'antd';
import { ReferencedTableItem } from '@project/components/Module/RecordCard/ReferencedTables/ReferencedTables';
import { getDisplayGeoJSONFeature } from '@project/store/shared/LayersTree/Tree/utils';
import { TableFeature } from '@project/components/Module/RecordCard/ReferencedTables/types';
import { GeoJSONCollectionWithAttachmentAndDisplay } from '@project/store/Table';
import { useStore } from '@project/components/hooks';
import { ListFilterParams } from '@project/components/Module/Table/Filters/FilterInput/constants';

const pageSize = 10;

export const ReferencedTableDisplay: FC<{ table: ReferencedTableItem }> = ({
  table,
}) => {
  const { tableWindow } = useStore();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<TableFeature[] | undefined>();

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const handlePaginationChange = (page: number) => {
    setPage(page);
  };

  const loadReferencedRecords = async () => {
    try {
      setIsLoading(true);
      const recordsResponse = await services.records.apiGeojsonList(
        table.table_name,
        page,
        pageSize,
        {
          query: {
            [table.referencedColumn]: table.columnValue,
            ['_display']: table.referencedColumn,
          },
        },
      );

      const records =
        recordsResponse.data as GeoJSONCollectionWithAttachmentAndDisplay;
      setTotal(records._count);

      const parsed: TableFeature[] = records.features.map((feature) => ({
        ...feature,
        listDisplay: table.display
          ? getDisplayGeoJSONFeature(feature, table.display)
          : '',
        _attachments: [],
      }));

      setData(parsed);
    } catch (e) {
      console.error(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadReferencedRecords();
  }, [table, page]);

  return (
    <div>
      {isLoading ? (
        <div className={'ref-table-loading'}>
          <Spin />
        </div>
      ) : data ? (
        <>
          <Button
            className={'view-ref-table-button'}
            onClick={() => {
              tableWindow.open(table.table_name, {
                table: table,
                filterParam: {
                  [table.referencedColumn]: {
                    operator: ListFilterParams.in,
                    value: Number(table.columnValue),
                  },
                },
              });
            }}
          >
            Просмотреть таблицу
          </Button>
          {data.map((item) => {
            return (
              <Fragment key={item.id}>
                <div key={item.id} className={'ref-table-display'}>
                  {`${table.description} - ${item.listDisplay}`}
                </div>
                <Divider style={{ margin: '5px 0' }} />
              </Fragment>
            );
          })}
          <div className={'ref-table-display-pagination'}>
            <Pagination
              simple
              current={page}
              pageSize={pageSize}
              total={total}
              onChange={handlePaginationChange}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
